import React from 'react';
import { SafetyOutlined } from '@ant-design/icons';

const PrivacyPolicy = () => {
  return (
    <div className="container py-5 privacy-policy-page">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-9">
          {/* Header Section */}
          <div className="text-center mb-5">
            <div 
              className="d-inline-flex align-items-center justify-content-center mb-4 privacy-header-icon"
              style={{
                width: '90px',
                height: '90px',
                borderRadius: '24px',
                background: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
                boxShadow: '0 8px 24px rgba(13, 110, 253, 0.3)'
              }}
            >
              <SafetyOutlined className="privacy-header-icon-svg" style={{ fontSize: '45px', color: '#fff' }} />
            </div>
            <h1 
              className="display-4 fw-bold mb-3 privacy-main-title"
              style={{
                background: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Privacy Policy
            </h1>
            <p className="text-muted mt-3 mb-0 privacy-updated-date" style={{ fontSize: '0.9rem' }}>
              Last updated: {new Date().toLocaleDateString()}
            </p>
        </div>

          {/* Content */}
          <div className="card border-0 shadow-sm mb-4 privacy-content-card" style={{ borderRadius: '16px' }}>
            <div className="card-body p-4 p-md-5 privacy-content-body">
              {/* Section 1 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  1. Introduction
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  MaveshiBids ("we", "us", "our") is Pakistan's first online real-time livestock and agriculture marketplace. We are committed to protecting your personal data and respecting your privacy. This Privacy Policy explains how we collect, use, store, disclose and otherwise handle your personal information when you use our platform, mobile app, website and related services ("Services").
                </p>
                <p className="text-muted mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  By accessing or using our Services, you agree to the terms of this Privacy Policy. If you do not agree, please do not use our Services.
                </p>
              </div>

              {/* Section 2 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  2. What Information We Collect
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We collect different types of information from you depending on how you interact with MaveshiBids:
                </p>
                
                <div className="mb-4">
                  <h5 className="fw-bold mb-2 privacy-subsection-title" style={{ color: '#212529', fontSize: '1.2rem' }}>
                    a) Identity & Contact Information:
                  </h5>
                  <ul className="text-muted privacy-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                    <li>Name, CNIC/NICOP/passport number, date of birth</li>
                    <li>Phone number (including WhatsApp), email address</li>
                    <li>Address, city, province, postal code</li>
                    <li>Profile image or selfie for verification</li>
        </ul>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold mb-2 privacy-subsection-title" style={{ color: '#212529', fontSize: '1.2rem' }}>
                    b) Account, Transaction & Marketplace Data:
                  </h5>
                  <ul className="text-muted privacy-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                    <li>Username, password, user role (buyer, seller, agent)</li>
                    <li>Listings you create (animal details, images, videos)</li>
                    <li>Bids/offers you submit, purchase history, sale history</li>
                    <li>Payment details and transaction records (bank account, wallet)</li>
                    <li>Verification status (ID verified, bank verified, tax ID verified)</li>
                    <li>Trust and reputation score data</li>
        </ul>
                </div>

                <div className="mb-0">
                  <h5 className="fw-bold mb-2 privacy-subsection-title" style={{ color: '#212529', fontSize: '1.2rem' }}>
                    c) Usage, Device & Technical Information:
                  </h5>
                  <ul className="text-muted privacy-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                    <li>IP address, device type, operating system, browser type</li>
                    <li>App usage data, logs, crash reports</li>
                    <li>Cookies, analytics, session-data</li>
                    <li>Location data (if you allow it), for delivery/pickup confirmation</li>
        </ul>
                </div>
              </div>

              {/* Section 3 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  3. How We Use Your Information
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We use your personal information for the following purposes:
                </p>
                <ul className="text-muted privacy-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>To register and manage your account, verify identity and eligibility</li>
                  <li>To provide, operate and improve our Services (listing operations, bidding system, notifications)</li>
                  <li>To communicate with you: send alerts, updates, newsletters, security messages</li>
                  <li>To process transactions, payments and refunds securely</li>
                  <li>To monitor and enforce compliance with our policies (Code of Conduct, operating rules)</li>
                  <li>To analyse usage and behaviour to improve functionality, and generate aggregated market insights</li>
                  <li>To protect fraudulent activity, ensure security and legal compliance</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  4. Sharing & Disclosure of Personal Information
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We will not sell your personal information. We may share or disclose your information under the following circumstances:
                </p>
                <ul className="text-muted privacy-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>With service providers / technology partners acting on our behalf (e.g., payment gateway, identity verification providers)</li>
                  <li>With relevant regulatory, law enforcement or government agencies when required by law</li>
                  <li>With other users of the platform only to the extent necessary for transactions (e.g., seller's contact information provided to buyer after sale)</li>
                  <li>In aggregated or anonymised form for statistical, analytic or market-reporting purposes</li>
                </ul>
              </div>

              {/* Section 5 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  5. Data Retention
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We keep your personal information only for as long as required to meet the purposes listed above or to comply with legal obligations.
                </p>
                <p className="text-muted mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  If your account is closed, we will retain necessary information for archival, legal, fraud-prevention or audit purposes, thereafter securely delete or anonymise it.
                </p>
              </div>

              {/* Section 6 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  6. Security of Your Information
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We take reasonable administrative, technical and physical security measures to protect your information from unauthorised access, misuse, alteration or destruction.
                </p>
                <p className="text-muted mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  However, no method of transmission over the internet or electronic storage can guarantee 100% security; we cannot guarantee the absolute security of your data.
                </p>
              </div>

              {/* Section 7 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  7. Your Rights & Choices
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  Depending on applicable law, you have certain rights:
                </p>
                <ul className="text-muted privacy-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li><strong>Access:</strong> request a copy of your personal data that we hold</li>
                  <li><strong>Correction:</strong> request correction or deletion of inaccurate or outdated data</li>
                  <li><strong>Objection or restriction:</strong> request us to restrict processing or object to certain processing</li>
                  <li><strong>Portability:</strong> request your data in a commonly used, machine-readable format</li>
                  <li><strong>Withdrawal of consent:</strong> Any consent you have given for data processing can be withdrawn (this may limit your ability to use some Services)</li>
        </ul>
                <p className="text-muted mt-3 mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  To exercise these rights, please contact us at [Insert email/support contact].
                </p>
              </div>

              {/* Section 8 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  8. Cookies & Similar Technologies
                </h2>
                <p className="text-muted mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We use cookies, web-beacons and similar technologies to collect technical and usage information. You can manage or disable cookies through your browser settings, but if you do so some features of our Services may not work.
                </p>
              </div>

              {/* Section 9 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  9. International Transfers
                </h2>
                <p className="text-muted mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  If we transfer your personal information outside Pakistan (e.g., to a cloud service provider in another country), we ensure appropriate safeguards are in place to protect that data in accordance with applicable law.
                </p>
              </div>

              {/* Section 10 */}
              <div className="mb-5 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  10. Changes to This Privacy Policy
                </h2>
                <p className="text-muted mb-0 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We may update this policy from time to time. The "last updated" date will be reflected at the top of the page. If changes are material, we will notify you via the platform or email. Continued use of our Services after the change means you accept the updated policy.
                </p>
              </div>

              {/* Section 11 */}
              <div className="mb-0 privacy-section">
                <h2 className="fw-bold mb-3 privacy-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  11. Contact Us
                </h2>
                <p className="text-muted mb-3 privacy-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
                </p>
                <div className="text-muted privacy-contact-info" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  <p className="mb-2">
                    <strong>Email:</strong> [Insert email]
                  </p>
                  <p className="mb-2">
                    <strong>Address:</strong> [Insert physical address]
                  </p>
                  <p className="mb-0">
                    <strong>Phone:</strong> +92-XXX-XXXXXXX
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        /* Responsive Styles */
        .privacy-policy-page {
          padding-top: 20px !important;
          padding-bottom: 40px !important;
        }

        /* Header Section - Mobile */
        .privacy-header-icon {
          width: 70px !important;
          height: 70px !important;
        }

        .privacy-header-icon-svg {
          font-size: 35px !important;
        }

        .privacy-main-title {
          font-size: 2rem !important;
        }

        .privacy-updated-date {
          font-size: 0.85rem !important;
        }

        /* Content Card - Mobile */
        .privacy-content-card {
          border-radius: 16px !important;
        }

        .privacy-content-body {
          padding: 20px !important;
        }

        .privacy-section {
          margin-bottom: 2rem !important;
        }

        .privacy-section-title {
          font-size: 1.4rem !important;
        }

        .privacy-section-text {
          font-size: 0.9rem !important;
          line-height: 1.7 !important;
        }

        .privacy-subsection-title {
          font-size: 1.1rem !important;
        }

        .privacy-list {
          font-size: 0.9rem !important;
          line-height: 1.8 !important;
          padding-left: 20px !important;
        }

        .privacy-contact-info {
          font-size: 0.9rem !important;
        }

        /* Tablet and up */
        @media (min-width: 768px) {
          .privacy-policy-page {
            padding-top: 40px !important;
            padding-bottom: 60px !important;
          }

          .privacy-header-icon {
            width: 90px !important;
            height: 90px !important;
          }

          .privacy-header-icon-svg {
            font-size: 45px !important;
          }

          .privacy-main-title {
            font-size: 2.5rem !important;
          }

          .privacy-updated-date {
            font-size: 0.9rem !important;
          }

          .privacy-content-body {
            padding: 32px !important;
          }

          .privacy-section-title {
            font-size: 1.75rem !important;
          }

          .privacy-section-text {
            font-size: 1rem !important;
            line-height: 1.8 !important;
          }

          .privacy-subsection-title {
            font-size: 1.2rem !important;
          }

          .privacy-list {
            font-size: 1rem !important;
            line-height: 2 !important;
            padding-left: 24px !important;
          }

          .privacy-contact-info {
            font-size: 1rem !important;
          }
        }

        /* Desktop and up */
        @media (min-width: 992px) {
          .privacy-main-title {
            font-size: 3rem !important;
          }

          .privacy-content-body {
            padding: 40px !important;
          }
        }

        /* Extra small devices */
        @media (max-width: 575px) {
          .privacy-policy-page {
            padding-top: 15px !important;
            padding-bottom: 30px !important;
          }

          .privacy-header-icon {
            width: 60px !important;
            height: 60px !important;
          }

          .privacy-header-icon-svg {
            font-size: 30px !important;
          }

          .privacy-main-title {
            font-size: 1.75rem !important;
          }

          .privacy-updated-date {
            font-size: 0.8rem !important;
          }

          .privacy-content-body {
            padding: 16px !important;
          }

          .privacy-section {
            margin-bottom: 1.5rem !important;
          }

          .privacy-section-title {
            font-size: 1.3rem !important;
          }

          .privacy-section-text {
            font-size: 0.85rem !important;
            line-height: 1.6 !important;
          }

          .privacy-subsection-title {
            font-size: 1rem !important;
          }

          .privacy-list {
            font-size: 0.85rem !important;
            line-height: 1.7 !important;
            padding-left: 18px !important;
          }

          .privacy-contact-info {
            font-size: 0.85rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy; 
